import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useWorkspaces() {
	/** Query */
	const query = useQuery({
		queryKey: ["workspaces"],
		queryFn: async () => {
			const response = await client.organizations.workspaces.$get();
			const data = await responseHandler(response);
			return data.workspaces;
		},
	});

	/** Return */
	return {
		...query,
		workspaces: query.data ?? [],
	};
}
